import { useEffect } from 'react';
import { READY, UPLOADING, PROCESSING, ANALYZING, FAILED } from '../constants';

import createT from 'T';
const T = createT();
T({
  'Uploading...': 'Envoi du fichier...',
  'Processing...': 'Finalisation...',
  'Analyzing...': 'Analyse en cours...',
  Ready: 'Disponible',
  'Request Entity Too Large': 'Le fichier est trop gros',
  'Upload failed': 'Le téléchargement a échoué',
  'Network error': 'Erreur réseau',
  'Unkown error': 'Erreur inconnue',
  'Timed out': 'Délai dépassé',
  'Internal Server Error': 'Erreur serveur',
});

import { useUpload } from '../selectors';
import { useUploadActions } from '../actions';

const Progression = ({ uuid, limit = 400 }) => {
  const upload = useUpload(uuid);
  const { clear } = useUploadActions();
  const { status, error, progress } = upload;
  useEffect(() => {
    if (status === READY) {
      const timer = setTimeout(() => clear(uuid), 2000);
      return () => clearTimeout(timer);
    }
  }, [status, clear, uuid]);
  if (status === UPLOADING) {
    return (
      <div>
        {T`Uploading...`}
        <progress
          className='progress w-50'
          value={progress}
          max={1}
        />
      </div>
    );
  }
  if (status === PROCESSING) {
    return (
      <div>
        {T`Processing...`}
        <progress className='progress progress-warning w-50' />
      </div>
    );
  }
  if (status === ANALYZING) {
    return (
      <div>
        {T`Analyzing...`}
        <progress className='progress progress-success w-50' />
      </div>
    );
  }
  if (status === FAILED) {
    return (
      <div className='error'>
        {T(typeof error?.message === 'string' ? error.message : 'Unkown error')}
      </div>
    );
  }

  return <div className='success'>Le média est prêt</div>;
};

export default Progression;
